import React, { Component } from 'react';
import PropTypes from 'prop-types';
import formatDate from 'date-fns/format';
import { connect } from 'react-redux';

class TimestampHeader extends Component {
    static propTypes = {
        conversationTimestampHeaderFormat: PropTypes.string.isRequired,
        dateFnLocale: PropTypes.object.isRequired,
        value: PropTypes.number.isRequired, // value is expected to be a unix utc timestamp (in seconds)
    };

    render() {
        const { value, conversationTimestampHeaderFormat, dateFnLocale } = this.props;
        const formattedValue = formatDate(new Date(value * 1000), conversationTimestampHeaderFormat, {
            locale: dateFnLocale,
        });
        return <div className="conversation-timestamp-header">{formattedValue}</div>;
    }
}

export default connect(
    ({
        ui: {
            text: { conversationTimestampHeaderFormat },
            dateFnLocale,
        },
    }) => {
        return { conversationTimestampHeaderFormat, dateFnLocale };
    },
)(TimestampHeader);
